/**
 * AddDefaultRowKey Handler для Table
 * 
 * Додає rowKey для рядків таблиці на основі id елемента
 */

/**
 * Додає rowKey для рядків таблиці
 * 
 * @param params - параметри з props
 */
export const AddDefaultRowKey = ({ props }: { props: any }) => {
    if (!props?.rowKey) {
        props.rowKey = (item: any) => `rowk-${item.id}`
    }
    return props
}
